import {
    IEtapa,
    IEtapaGrupo,
    IEtapaPorGrupo,
    IListarEtapaGrupoNaoVinculadosFixo,
    IListarEtapaGrupoVinculadosFixo,
    IListarEtapas,
    IVincularDesvincularAcaoEtapa,
} from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import { ICategoriaAtendimento } from "../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarEtapasService(
    idTipoCaso: number,
    idCategoria: number | number[]
) {
    return Service(
        Axios.get<Array<IEtapa>>(
            `/home/etapacategoriaatendimento/listetapasporcategoriaatendimentoetipocaso?ID_TIPO_CASO=${idTipoCaso}&ID_CATEGORIA_ATENDIMENTO=${idCategoria}`
        )
    );
}

export async function ListarEtapasPorCategoriaETipoCasoService(
    ID_TIPO_CASO: number,
    ID_CATEGORIA_ATENDIMENTO: number | number[]
) {
    return Service(
        Axios.post<Array<IEtapa>>(
            `/home/etapacategoriaatendimento/listetapasporvariascategoriasatendimentoetipocaso`,
            {
                ID_TIPO_CASO,
                ID_CATEGORIA_ATENDIMENTO,
            }
        )
    );
}

export async function InserirEtapaService(requestBody: IEtapa) {
    return Service(
        Axios.post(
            `/home/etapacategoriaatendimento/inseriretapacategoriaatendimentotipocaso`,
            requestBody
        )
    );
}

export async function DeletarEtapaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Service(
        Axios.delete(
            `/home/etapacategoriaatendimento/deletaretapacategoriaatendimentotipocaso?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function AtualizarEtapaService(requestBody: Partial<IEtapa>) {
    return Service(
        Axios.put(
            `/home/etapacategoriaatendimento/atualizaretapacategoriaatendimentotipocaso`,
            requestBody
        )
    );
}

export async function VincularEtapaGrupoDinamicaService(
    idGrupo: number,
    idEtapaCategoriaAtendimentoTipoCaso: number
) {
    return Service(
        Axios.post(
            `/home/etapacategoriaatendimento/VincularGrupoCategoriaAtendimentoEtapaTipoCaso?idGrupo=${idGrupo}&idEtapaCategoriaAtendimentoTipoCaso=${idEtapaCategoriaAtendimentoTipoCaso}`
        )
    );
}

export async function VincularEtapaGrupoFixaService(
    idGrupo: number,
    idEtapaTipoCaso: number
) {
    return Service(
        Axios.post(
            `/home/etapatipocaso/vinculargrupoetapatipocaso?idGrupo=${idGrupo}&idEtapaTipoCaso=${idEtapaTipoCaso}`
        )
    );
}

export async function DesvincularEtapaGrupoDinamicaService(
    idEtapaCategoriaAtendimentoTipoCasoGrupo: number
) {
    return Service(
        Axios.delete(
            `/home/etapacategoriaatendimento/DesvincularGrupoCategoriaAtendimentoEtapaTipoCaso?idEtapaCategoriaAtendimentoTipoCasoGrupo=${idEtapaCategoriaAtendimentoTipoCasoGrupo}`
        )
    );
}

export async function DesvincularEtapaGrupoFixaService(
    idEtapaTipoCasoGrupo: number
) {
    return Service(
        Axios.delete(
            `/home/etapatipocaso/desvinculargrupoetapatipocaso?idEtapaTipoCasoGrupo=${idEtapaTipoCasoGrupo}`
        )
    );
}

export async function GetEtapaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Service(
        Axios.get<IEtapa>(
            `/home/etapacategoriaatendimento/getetapacategoriaatendimentotipocaso?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function ListarGrupoVinculadosPorEtapaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<IEtapaGrupo>>(
            `/home/etapacategoriaatendimento/listargruposvinculadosporetapacategoriaatendimentotipocaso?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function ListarGrupoVinculadosPorEtapaFixaService(
    idEtapaTipoCaso: number
) {
    return Service(
        Axios.get<Array<IListarEtapaGrupoVinculadosFixo>>(
            `/home/etapatipocaso/listargruposvinculadosporetapatipocaso?idEtapaTipoCaso=${idEtapaTipoCaso}`
        )
    );
}

export async function ListarGrupoNaoVinculadosPorEtapaFixaService(
    idEtapaTipoCaso: number
) {
    return Service(
        Axios.get<Array<IListarEtapaGrupoNaoVinculadosFixo>>(
            `/home/etapatipocaso/listargruposnaovinculadosporetapatipocaso?idEtapaTipoCaso=${idEtapaTipoCaso}`
        )
    );
}

export async function ListarGrupoDesvinculadosPorEtapaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Service(
        Axios.get<Array<IEtapaGrupo>>(
            `/home/etapacategoriaatendimento/listargruposnaovinculadosporcategoriaatendimentotipocaso?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function AtualizarOrdemEtapaService(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    NR_ETAPA_DESTINO: number
) {
    return Service(
        Axios.post(
            `/home/etapacategoriaatendimento/alterarordemetapas?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}&NR_ETAPA_DESTINO=${NR_ETAPA_DESTINO}`
        )
    );
}

export async function ListarEtapasDesvinculadasGrupoService(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IEtapaPorGrupo>>(
            `/home/etapacategoriaatendimentotipocasogrupo/listaretapasdesvinculadasporgrupo?idGrupo=${idGrupo}&idCategoriaAtendimento=${idCategoriaAtendimento}&idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarEtapasVinculadasGrupoService(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IEtapaPorGrupo>>(
            `/home/etapacategoriaatendimentotipocasogrupo/listaretapasporgrupo?idGrupo=${idGrupo}&idCategoriaAtendimento=${idCategoriaAtendimento}&idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarCategoriaTipoCasoService(idTipoCaso: number) {
    return Service(
        Axios.get<Array<ICategoriaAtendimento>>(
            `/home/listarcategoriaatendimentotipocaso/listarcategoriaatendimentotipocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarEtapasPorCategoriaAtendimentoETipoCasoService(
    idCaso: number,
    idTipoCaso?: number
) {
    return Service(
        Axios.get<Array<IListarEtapas>>(
            `/home/etapacategoriaatendimento/listetapascategoriaatendimentoouetapatipocaso?idCaso=${idCaso}&idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function VincularGrupoAcaoService(
    requestBody: IVincularDesvincularAcaoEtapa
) {
    return Service(
        Axios.post(
            `/home/etapacategoriaatendimento/vinculargrupoacao`,
            requestBody
        )
    );
}

export async function DesvincularGrupoAcaoService(
    ID_GRUPO: number,
    ID_ACAO: number
) {
    return Service(
        Axios.delete(
            `/home/etapacategoriaatendimento/desvinculargrupoacao?ID_GRUPO=${ID_GRUPO}&ID_ACAO=${ID_ACAO}`
        )
    );
}
